import React from 'react';
import PropTypes from 'prop-types';

export const GiftIconV2 = ({
  width,
  height,
  displayType,
  fillColor,
  strokeColor,
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 20H11C11 20.5523 11.4477 21 12 21V20ZM13 13H19V11H13V13ZM19 13V19H21V13H19ZM19 19H12V21H19V19ZM13 20V13H11V20H13ZM19 19H19V21C20.1046 21 21 20.1046 21 19H19ZM19 13H19H21C21 11.8954 20.1046 11 19 11V13ZM13 11C11.8954 11 11 11.8954 11 13H13V11Z"
        fill={displayType === 'outline' ? '#AAABAE' : fillColor}
      />
      <path
        d="M12 20V21C12.5523 21 13 20.5523 13 20H12ZM5 13H11V11H5V13ZM11 13V20H13V13H11ZM12 19H5V21H12V19ZM5 19V13H3V19H5ZM5 19H3C3 20.1046 3.89543 21 5 21V19ZM11 13H11H13C13 11.8954 12.1046 11 11 11V13ZM5 11C3.89543 11 3 11.8954 3 13H5V11Z"
        fill={displayType === 'outline' ? '#AAABAE' : fillColor}
      />
      <path
        d="M20 8H13C12.4477 8 12 8.44772 12 9V11C12 11.5523 12.4477 12 13 12H20C20.5523 12 21 11.5523 21 11V9C21 8.44772 20.5523 8 20 8Z"
        stroke={displayType === 'outline' ? strokeColor : fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 8H4C3.44772 8 3 8.44772 3 9V11C3 11.5523 3.44772 12 4 12H11C11.5523 12 12 11.5523 12 11V9C12 8.44772 11.5523 8 11 8Z"
        stroke={displayType === 'outline' ? strokeColor : fillColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8H11C11 8.55228 11.4477 9 12 9V8ZM11 5.5V8H13V5.5H11ZM12 9H14.5V7H12V9ZM14.5 9C16.433 9 18 7.433 18 5.5H16C16 6.32843 15.3284 7 14.5 7V9ZM14.5 2C12.567 2 11 3.567 11 5.5H13C13 4.67157 13.6716 4 14.5 4V2ZM14.5 4C15.3284 4 16 4.67157 16 5.5H18C18 3.567 16.433 2 14.5 2V4Z"
        fill={displayType === 'outline' ? '#AAABAE' : fillColor}
      />
      <path
        d="M12 8V9C12.5523 9 13 8.55228 13 8H12ZM11 5.5V8H13V5.5H11ZM12 7H9.5V9H12V7ZM9.5 7C8.67157 7 8 6.32843 8 5.5H6C6 7.433 7.567 9 9.5 9V7ZM9.5 4C10.3284 4 11 4.67157 11 5.5H13C13 3.567 11.433 2 9.5 2V4ZM9.5 2C7.567 2 6 3.567 6 5.5H8C8 4.67157 8.67157 4 9.5 4V2Z"
        fill={displayType === 'outline' ? '#AAABAE' : fillColor}
      />
    </svg>
  );
};

GiftIconV2.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  displayType: PropTypes.oneOf(['outline', 'filled']),
  fillColor: PropTypes.string,
  strokeColor: PropTypes.string,
};

GiftIconV2.defaultProps = {
  width: '24',
  height: '24',
  fillColor: '#FBC91B',
  strokeColor: '#AAABAE',
};
